import { render, staticRenderFns } from "./TextEditor2.vue?vue&type=template&id=4e161064&"
import script from "./TextEditor2.vue?vue&type=script&lang=js&"
export * from "./TextEditor2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/agent_ai/agent-ai-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e161064')) {
      api.createRecord('4e161064', component.options)
    } else {
      api.reload('4e161064', component.options)
    }
    module.hot.accept("./TextEditor2.vue?vue&type=template&id=4e161064&", function () {
      api.rerender('4e161064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/TextEditor2.vue"
export default component.exports